var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { PageService } from '~/utils/page.service';
import { UserService } from '~/services/management-service/user.service';
import { RoleService } from '~/services/management-service/role.service';
import { Emit, Prop } from 'vue-property-decorator';
var AllotRole = /** @class */ (function (_super) {
    __extends(AllotRole, _super);
    function AllotRole() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            roleName: '',
            companyCode: _this.companyCode,
            roleStatus: 'ENABLED',
        };
        _this.selectionList = [];
        // 设置角色对象
        _this.roleSetModel = {
            roleIds: [],
            userId: '',
            caseSwitch: '',
            userIds: [],
            userLevel: 'A',
        };
        _this.dataSet = [];
        return _this;
    }
    AllotRole.prototype.refreshList = function () {
        this.selectionList = [];
    };
    AllotRole.prototype.close = function () {
        this.model.roleName = '';
    };
    // 刷新数据
    AllotRole.prototype.refreshData = function () {
        var _this = this;
        this.selectionList = [];
        this.roleService.getAllRoles(this.model, this.pageService).subscribe(function (data) {
            _this.dataSet = data;
            _this.user.roleIds.forEach(function (v, index) {
                _this.selectionList.push(data.find(function (value) { return value.id === v; }));
            });
        });
    };
    AllotRole.prototype.confirm = function () {
        var _this = this;
        if (this.selectionList.length === 0) {
            this.$message.info('请选择角色');
            return;
        }
        this.roleSetModel.userId = this.user.id;
        this.roleSetModel.roleIds = this.selectionList.map(function (x) { return x.id; });
        this.roleSetModel.userIds = [this.user.id];
        this.roleSetModel.caseSwitch = this.user.caseSwitch;
        this.userService.batchAllotRole(this.roleSetModel).subscribe(function (data) {
            _this.$message.success('分配成功');
            _this.refreshList();
            _this.close();
        });
    };
    __decorate([
        Dependencies(PageService)
    ], AllotRole.prototype, "pageService", void 0);
    __decorate([
        Dependencies(UserService)
    ], AllotRole.prototype, "userService", void 0);
    __decorate([
        Dependencies(RoleService)
    ], AllotRole.prototype, "roleService", void 0);
    __decorate([
        Prop()
    ], AllotRole.prototype, "user", void 0);
    __decorate([
        Prop()
    ], AllotRole.prototype, "companyCode", void 0);
    __decorate([
        Emit('refreshList')
    ], AllotRole.prototype, "refreshList", null);
    __decorate([
        Emit('close')
    ], AllotRole.prototype, "close", null);
    AllotRole = __decorate([
        Component({
            components: {},
        })
    ], AllotRole);
    return AllotRole;
}(Vue));
export default AllotRole;
